module.exports = __webpack_public_path__ + "img/chemically_safe.37bb0bf3.jpg";